import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

/**
 *
 * @param {Object} params
 * @param {String} actionType
 * @return {function(*)}
 * @private
 */
const _getManyWelcomeAssets = (params, actionType) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.adminServerUrl}/welcomeassets`;
    const url = buildQueryString(rest, baseUrl);

    return (dispatch) => {
        dispatch({
            type: ACTIONS.GET_MANY_WELCOME_ASSETS_START
        });
        return VerbFetch(url).then((body) => {
            dispatch({
                type: actionType,
                payload: {
                    welcomeAssets: body
                }
            });
            return body;
        });
    };
};

/**
 *
 * @param {Object} params
 * @return {function(*)}
 */
export const getManyWelcomeAssets = (params) => _getManyWelcomeAssets(params, ACTIONS.GET_MANY_WELCOME_ASSETS);

export const getWelcomeAsset = (params) => {
    const { welcomeAssetId, dispatchDisabled, onlyActive = false, pathsContext } = params;
    let url = `${pathsContext.serverUrl}/welcomeassets/${welcomeAssetId}`;
    url = buildQueryString({ onlyActive }, url);

    if (dispatchDisabled) {
        return VerbFetch(url);
    }

    return (dispatch) =>
        VerbFetch(url).then((body) => {
            dispatch({
                type: ACTIONS.GET_WELCOME_ASSET,
                payload: {
                    welcomeAsset: body
                }
            });

            return body;
        });
};

export const postWelcomeAsset = (params) => {
    const { body, pathsContext } = params;

    return (dispatch) => {
        dispatch({
            type: ACTIONS.POST_WELCOME_ASSET_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/welcomeassets`, {
            method: 'POST',
            body
        }).then((body) => {
            dispatch({
                type: ACTIONS.POST_WELCOME_ASSET_SUCCESS,
                payload: {
                    welcomeAsset: body
                }
            });
            return body;
        });
    };
};

export const putWelcomeAsset = (params) => {
    const { welcomeAssetId, body, pathsContext } = params;

    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_WELCOME_ASSET_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/welcomeassets/${welcomeAssetId}`, {
            method: 'PUT',
            body
        }).then((body) => {
            dispatch({
                type: ACTIONS.PUT_WELCOME_ASSET_SUCCESS,
                payload: {
                    welcomeAsset: body
                }
            });
            return body;
        });
    };
};
